import React, { useEffect, useState } from 'react';
import { Button, Layout, Dropdown, Menu, Drawer, Modal } from 'antd';
import { UserOutlined, MenuOutlined, LogoutOutlined, DashboardOutlined, FileSearchOutlined, AimOutlined, BarChartOutlined, PoweroffOutlined, LoginOutlined, TeamOutlined, UserAddOutlined, UserDeleteOutlined, KeyOutlined  } from '@ant-design/icons';
import ThemeDropdown from '../../common/theme/ThemeDropdown';
import logo from '../../../assets/icons/logo.png';
import { AlertMessages, SWITCH_TEXT, TEXT_CONSTANTS } from '../../../constants/Constants';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetSignup } from '../../../redux/slices/signupSlice';
import InviteForm from './InviteForm';
import DeleteUserForm from './DeleteUserForm';

const { Header } = Layout;
const { confirm } = Modal;

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false); 
  const [menuOpen, setMenu] = useState(false);
  const emailId = sessionStorage.getItem("Email")
  const supplierId=sessionStorage.getItem("supplierId")
  const isLoggedIn = sessionStorage.getItem("isLoggedIn")
  const Name = sessionStorage.getItem("firstName")
  const dispatch=useDispatch();
  const [inviteFormVisible, setInviteFormVisible] = useState(false);
  const [deleteUserFormVisible, setDeleteUserFormVisible] = useState(false);
  const [showUserOptions, setShowUserOptions] = useState(false);

  const role=sessionStorage.getItem("Role")

  const handleMenuClick = () => {
    setVisible(!visible); // Toggle dropdown visibility
  };

  const toggleDropdown = () => {
    setVisible(!visible);
  };

  const handleMenu = () => {
    setMenu(true);
  }

  const handleProfileClick = () => {
    navigate("/signup")
  }

  const handleLogOutClick = () => {
    const logOut = () => {
      dispatch(resetSignup())
      sessionStorage.clear();
      navigate("/UserType")
    }
    if (isLoggedIn) {
      confirm({
        title: AlertMessages.LOG_OUT,
        okText: SWITCH_TEXT.YES,
        cancelText: SWITCH_TEXT.NO,
        onOk() {
          logOut();
        },
      });
    }
    else {
      logOut();
    }
  }

  const handleAddUser = () => {
    setInviteFormVisible(true);
    setVisible(false);
    setShowUserOptions(false);
  };

  const handleRolesPermissions = () => {
    navigate("/admin/roles-permissions/entities");
    setVisible(false);
    setMenu(false);
  };

  const handleDeleteUser = () => {
    setDeleteUserFormVisible(true);
    setVisible(false);
    setShowUserOptions(false);
  };

  const toggleUserOptions = () => {
    setShowUserOptions(!showUserOptions);
  };

  const userManagementMenu = () => (
    <>
      <Menu.Item key="userManagement" onClick={toggleUserOptions}>
        <span className="flex items-center justify-between capitalize">
          <span className="flex items-center">
            Manage Users
          </span>
          <span className="text-xs ml-2">
            {showUserOptions ? '▲' : '▼'}
          </span>
        </span>
      </Menu.Item>
      
      {showUserOptions && (
        <>
          <Menu.Item key="addUser" onClick={handleAddUser} className="pl-8">
            <span className="flex items-center pl-2">
              <UserAddOutlined className="mr-3" />
              Add Users
            </span>
          </Menu.Item>
          <Menu.Item key="deleteUser" onClick={handleDeleteUser} className="pl-8">
            <span className="flex items-center pl-2">
              <UserDeleteOutlined className="mr-3" />
              Delete Users
            </span>
          </Menu.Item>
        </>
      )}
    </>
  );

  const menu = (
    <Menu>
      <Menu.Item>
        <h1><b>Hello, {Name}</b></h1>
      </Menu.Item>
      {(role=="System admin") && (<></>)}

      {(isLoggedIn && (role === "Supplier Admin" || role === "Supplier User")) && (
        <Menu.Item onClick={handleProfileClick}>
          <div className='capitalize'>Profile</div>
        </Menu.Item>)}
      
      {role==="Supplier Admin" && userManagementMenu()}
      {role==="System Admin" && (
        <Menu.Item onClick={handleRolesPermissions}>
          <div className='capitalize'>Entities</div>
        </Menu.Item>
      )}
      
      <Menu.Item key="logout" onClick={handleLogOutClick}>
        <div className='flex space-x-4' >
          {Name !== "USER" ? (
            <>
              <h2 className="capitalize">Log Out</h2>
              <PoweroffOutlined />
            </>) : (
            <>
              <h2 className="capitalize">Log In</h2>
              <LoginOutlined />
            </>
          )}
        </div>
      </Menu.Item>
    </Menu>
  );

  const NavItem = ({ to, icon, text }) => (
    <NavLink />
  )

  return (
    <div>
      <Header className="flex justify-between items-center bg-primary text-white h-[70px] px-[20px] md:px-[50px] font-poppins font-bold">
        <div className="flex items-center  md:ml-0">
          <MenuOutlined 
            onClick={handleMenu} 
            className="block md:hidden text-xl mr-3" 
          />
          <Drawer
            title="Menu"
            placement="left"
            closable={true}
            open={menuOpen}
            onClose={() => setMenu(false)}
            width={250}
          >
            {location.pathname.includes("/admin") ? (
              <>
                <div className="flex flex-col space-y-4 w-full px-2 mt-2">
                  <NavLink
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                        ? "bg-primary text-white"
                        : "text-[#6B7280] hover:bg-gray-100"
                      }`
                    }
                    to={"dashboard"}
                    onClick={() => setMenu(false)} 
                  >
                    <DashboardOutlined className="pr-3 text-lg" />
                    <span  className="font-medium text-base ">Dashboard</span>
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                        ? "bg-primary text-white"
                        : "text-[#6B7280] hover:bg-gray-100"
                      }`
                    }
                    to={"suppliersearch"}
                    onClick={() => setMenu(false)} 
                  >
                    <FileSearchOutlined className="pr-3 text-lg" />
                    <span className="text-medium text-base ">Supplier Search</span>
                  </NavLink>
                </div>
              </>
            ) : (
              <>
              <div className="flex flex-col space-y-4 w-full px-2 mt-2">
                <NavLink
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                      ? "bg-primary text-white"
                      : "text-[#6B7280] hover:bg-gray-100"
                    }`
                  }
                  to={"dashboard"}
                  onClick={() => setMenu(false)} 
                >
                  <DashboardOutlined className="pr-3 text-lg" />
                  <span  className="font-medium text-base ">Dashboard</span>
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                      ? "bg-primary text-white"
                      : "text-[#6B7280] hover:bg-gray-100"
                    }`
                  }
                  to={"reporting"}
                  onClick={() => setMenu(false)} 
                >
                  <BarChartOutlined className="pr-3 text-lg" />
                  <span className="text-medium text-base ">Reporting</span>
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                      ? "bg-primary text-white"
                      : "text-[#6B7280] hover:bg-gray-100"
                    }`
                  }
                  to={"goals"}
                  onClick={() => setMenu(false)} 
                >
                  <AimOutlined className="pr-3 text-lg" />
                  <span className="text-medium text-base ">Goals</span>
                </NavLink>

                 {/* Add User Roles and Permissions link for Supplier Admin only */}
                 {role === "Supplier Admin" && (
                  <NavLink
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-md transition-colors ${isActive
                        ? "bg-primary text-white"
                        : "text-[#6B7280] hover:bg-gray-100"
                      }`
                    }
                    to={"roles-permissions/entities"}
                    onClick={() => setMenu(false)} 
                  >
                    <KeyOutlined className="pr-3 text-lg" />
                    <span className="text-medium text-base ">User Roles & Permissions</span>
                </NavLink>
                )}
              </div>
            </>
            )}
          </Drawer>
          <img src={logo} alt="Logo" className="h-[40px] md:h-[50px] mr-3" />
          <div className="text-sm md:text-lg">{TEXT_CONSTANTS.HEADER_TEXT}</div>
        </div>

        <Dropdown
          overlay={menu}
          visible={visible}
          onClick={handleMenuClick}
          onVisibleChange={(flag) => {
                setVisible(flag);
                if (!flag) {
                  setShowUserOptions(false);
                }
          }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button 
            onClick={toggleDropdown}
            className="h-[48px] w-[48px] rounded-full text-[25px] bg-[white] text-[black]"
          >
            <UserOutlined className="text-black" />
          </Button>
        </Dropdown>
      </Header>

      <Drawer
        title={TEXT_CONSTANTS.HEADER_TEXT}
        titleStyle={{ fontSize: '16px', fontWeight: 'bold' }}
        placement="right"
        onClose={() => setDrawerVisible(false)}
        visible={drawerVisible}
      >
        <Menu>
          <Menu.Item>
            <ThemeDropdown />
          </Menu.Item>
          <Menu.Item>
            <Button> LOG OUT</Button>
          </Menu.Item>
        </Menu>
      </Drawer>
      <InviteForm 
        isVisible={inviteFormVisible}
        onClose={() => setInviteFormVisible(false)}
        supplierId={supplierId}
      />
      <DeleteUserForm 
        isVisible={deleteUserFormVisible}
        onClose={() => setDeleteUserFormVisible(false)}
        emailId={emailId}
      />
    </div>
  );
};

export default Navbar;
